/**
 * Shared HEVC codec-string assembly.
 *
 * The HEVC general profile_tier_level() (12 bytes) has one canonical layout,
 * and it appears verbatim in two places the viewers read from:
 *  - the SPS bitstream (live Annex-B path, dview/lite live/wsplayer/PlayerWS.js), and
 *  - the hvcC MP4 box, bytes desc[1..12] (playback path, player/PlaybackPlayer.js).
 * Both must produce byte-identical WebCodecs strings, so the assembly lives here
 * once rather than being copied per player (which previously drifted risk).
 *
 * @param {Uint8Array} ptl 12 general_* bytes: [profile_byte, compat[4], constraint[6], level_idc]
 * @param {string} [fourcc="hvc1"] sample-entry fourcc for the string prefix (hvc1 / hev1)
 * @returns {string} e.g. "hvc1.1.6.L150.90" (Main, compat 6, Level 5.0)
 */
export function hevcCodecStringFromPtl(ptl, fourcc = "hvc1") {
	const profileByte = ptl[0];
	const profileSpace = (profileByte >> 6) & 0x3;
	const tierFlag = (profileByte >> 5) & 0x1;
	const profileIdc = profileByte & 0x1F;
	const compat = ((ptl[1] << 24) | (ptl[2] << 16) | (ptl[3] << 8) | ptl[4]) >>> 0;
	let reversed = 0;
	for (let b = 0; b < 32; b++) if (compat & (1 << b)) reversed |= (1 << (31 - b));
	reversed = reversed >>> 0;
	const levelIdc = ptl[11];
	const constraintBytes = [];
	for (let b = 5; b <= 10; b++) constraintBytes.push(ptl[b].toString(16).padStart(2, "0").toUpperCase());
	while (constraintBytes.length > 1 && constraintBytes[constraintBytes.length - 1] === "00") constraintBytes.pop();
	const spacePrefix = profileSpace === 0 ? "" : String.fromCharCode(64 + profileSpace);
	return `${fourcc}.${spacePrefix}${profileIdc}.${reversed.toString(16).toUpperCase()}.${tierFlag ? "H" : "L"}${levelIdc}.${constraintBytes.join(".")}`;
}
